<template>
    <div>
        <canvas ref="canvas" @click="handleClick"></canvas>
    </div>
</template>

<script>
import VueChartJS from "vue-chartjs";

// 차트에 세로 보조선을 그려주는 플러그인
const verticalLinePlugin = {
    afterDraw(chart) {
        const opts = chart.config.options || {};
        const xValue = opts.customXAxis; // 우리가 props로 전달한 값이 여기로 들어옴
        if (xValue === undefined || xValue === null) return;

        // Chart.js 2.x / 3.x 호환 처리
        const xScale = chart.scales?.["x-axis-0"] || chart.scales?.x || chart.scales?.["x"];
        const yScale = chart.scales?.["y-axis-0"] || chart.scales?.y || chart.scales?.["y"];
        if (!xScale || !yScale || !chart.chartArea) return;

        let xPixel;

        // 1) 카테고리(레이블) 축인 경우: 레이블 인덱스로 픽셀 계산
        if (Array.isArray(chart.data?.labels)) {
            const idx = chart.data.labels.indexOf(xValue);
            if (idx !== -1 && typeof xScale.getPixelForTick === "function") {
                xPixel = xScale.getPixelForTick(idx);
            }
        }

        // 2) 시간/연속 축인 경우: 실제 값으로 픽셀 계산
        if ((xPixel === undefined || Number.isNaN(xPixel)) && typeof xScale.getPixelForValue === "function") {
            xPixel = xScale.getPixelForValue(xValue);
        }

        if (xPixel === undefined || Number.isNaN(xPixel)) return;

        const { top, bottom } = chart.chartArea;
        const ctx = chart.ctx;

        ctx.save();
        ctx.beginPath();
        ctx.moveTo(xPixel, top);
        ctx.lineTo(xPixel, bottom);
        ctx.lineWidth = (opts.verticalLine && opts.verticalLine.width) || 1;
        ctx.strokeStyle = (opts.verticalLine && opts.verticalLine.color) || "#999";
        const dash = (opts.verticalLine && opts.verticalLine.dash) || [];
        if (dash.length) ctx.setLineDash(dash);
        ctx.stroke();
        ctx.restore();
    },
};

export default {
    extends: VueChartJS.Bar,
    mixins: [VueChartJS.mixins.reactiveProp],
    props: ["context", "chartData", "options", "customXAxis"],
    data() {
        return {};
    },
    mounted() {
        // 플러그인 등록 (vue-chartjs v3의 addPlugin 지원)
        if (typeof this.addPlugin === "function") {
            this.addPlugin(verticalLinePlugin);
        }

        // options를 복제해서 customXAxis와(선택) verticalLine 기본 스타일 주입
        const mergedOptions = Object.assign(
            {
                customXAxis: this.customXAxis,
                verticalLine: {
                    color: "#FF8C00", // 주황색
                    width: 2, // 기본 두께
                    dash: [2, 2], // 점선
                },
            },
            this.options || {}
        );

        // 차트 렌더
        this.renderChart(this.chartData, mergedOptions);
    },
    watch: {
        // customXAxis가 변경되면 보조선 위치를 갱신
        customXAxis() {
            const chart = this.$data._chart;
            if (chart) {
                chart.config.options.customXAxis = this.customXAxis;
                chart.update();
            }
        },
        // 옵션 객체가 외부에서 교체될 수도 있으니 반영
        options: {
            deep: true,
            handler(newOpts) {
                const chart = this.$data._chart;
                if (chart && newOpts) {
                    chart.config.options = Object.assign(
                        {
                            customXAxis: this.customXAxis,
                            verticalLine: {
                                color: "#FF8C00", // 주황색
                                width: 1,
                                dash: [4, 2], // 점선
                            },
                        },
                        newOpts
                    );
                    chart.update();
                }
            },
        },
    },
    methods: {
        handleClick(event) {
            const chart = this.$data._chart;
            const elements = chart.getElementsAtEventForMode(event, "nearest", { intersect: true }, true);

            if (elements.length > 0) {
                // Chart.js 2.x 호환: _index, 3.x: index
                const elementIndex = elements[0]._index !== undefined ? elements[0]._index : elements[0].index;

                const xValue = this.chartData.labels[elementIndex];
                const yValue = this.chartData.datasets[0].data[elementIndex];

                this.$emit("chartClick", this.context, event, { xValue, yValue });
            }
        },
    },
};
</script>
